import Copy from './copy';
import CtaBox from './cta-box';
import ExternalVideo from './external-video';
import FullBleedImage from './full-bleed-image';
import Gallery from './gallery';
import LoveStoryGrid from './love-story-grid';
import MediaHero from './media-hero';
import ProductCardsBox from './product-cards-box';
import Quote from './quote';
import QuoteCarousel from './quote-carousel';
import QuoteCarouselCustom from './quote-carousel-custom';
import QuoteWithCta from './quote-with-cta';
import StackedCardsBox from './stacked-cards-box';

export default function BlocksRenderer({ blocks }: { blocks: any }) {
  const blocksToRender = blocks.map((block: any, index: number) => {
    switch (block._modelApiKey) {
      case 'copy':
        return <Copy key={index} data={block} />;
      case 'cta_box':
        return <CtaBox key={index} data={block} />;
      case 'external_video':
        return <ExternalVideo key={index} data={block} />;
      case 'full_bleed_image':
        return <FullBleedImage key={index} data={block} />;
      case 'gallery':
        return <Gallery key={index} data={block} />;
      case 'love_story_grid':
        return <LoveStoryGrid key={index} data={block} />;
      case 'media_hero':
        return <MediaHero key={index} data={block} />;
      case 'product_card_box':
        return <ProductCardsBox key={index} data={block} />;
      case 'quote':
        return <Quote key={index} data={block} />;
      case 'quote_carousel':
        return <QuoteCarousel key={index} data={block} />;
      case 'quote_carousel_basic':
        return <QuoteCarouselCustom key={index} data={block} />;
      case 'quote_with_cta':
        return <QuoteWithCta key={index} data={block} />;
      case 'stacked_cards_box':
        return <StackedCardsBox key={index} data={block} />;
      default:
        return null;
    }
  });

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '40px',
        paddingBottom: '40px',
      }}
    >
      {blocksToRender}
    </div>
  );
}
